module.exports = __webpack_public_path__ + "static/media/blind-date-banner.82aefb23.jpg";